import { environment as env } from "environments/environments"
export interface NavegacionSolicitudes{
    seccion: number
    titulo: string
}

export const navegacionTareas:NavegacionSolicitudes[]=[
    {
        seccion: env.TIPOLOGIA_ID_SECCION_PREHISPANICA,
        titulo:'Sección Prehispánica'
    },
    {
        seccion: env.TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA,
        titulo:'Sección Hispánica y Republicana'
    },
    {
        seccion: env.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES,
        titulo:'Sección Bienes Inmuebles'
    }
]


export const SeccionBienesCulturales:NavegacionSolicitudes[]=[
    {
        seccion: env.TIPOLOGIA_ID_SECCION_PREHISPANICA,
        titulo:'Prehispánica'
    },
    {
        seccion: env.TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA,
        titulo:'Hispánica Republicana'
    },
    {
        seccion: env.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES,
        titulo:'Bienes Inmuebles'
    }
]

